export const environment = {
	heading: 'Development',
	production: false,
	apiUrl: 'https://api.dev.gateway.tourboplus.com/api',
	netviaxApiKey:"0280efc8-df1c-4052-bcae-c81cad4cf967",
	recaptchaV2Key: '6LfcteoqAAAAAB91l4fwcXH82ku6Avnl69K9p0m-'
};